import { render, staticRenderFns } from "./SimpleLineIcons.vue?vue&type=template&id=739b2aa8&"
import script from "./SimpleLineIcons.vue?vue&type=script&lang=js&"
export * from "./SimpleLineIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports